import { MessageCircle } from 'lucide-react';
import { CONTACT_INFO } from '../../utils/constants';

/**
 * Floating WhatsApp button for quick contact
 */
const WhatsAppButton = () => {
  return (
    <a
      href={CONTACT_INFO.whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 group"
      aria-label="Contact us on WhatsApp"
    >
      <div className="relative">
        {/* Pulse animation */}
        <span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-25" />
        
        {/* Button */}
        <div className="relative flex items-center justify-center w-14 h-14 bg-green-500 rounded-full shadow-lg hover:bg-green-600 hover:scale-110 transition-all duration-300">
          <MessageCircle className="w-7 h-7 text-white" aria-hidden="true" />
        </div>
        
        {/* Tooltip */}
        <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 px-3 py-2 bg-neutral-800 text-white text-sm rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Chat with us!
          <span className="absolute left-full top-1/2 -translate-y-1/2 border-8 border-transparent border-l-neutral-800" aria-hidden="true" />
        </span>
      </div>
    </a>
  );
};

export default WhatsAppButton;
